import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { TagCategoryItem } from '@/entities/tags';

export const getTagCategoryDetailApi = async (categoryName: string): Promise<TagCategoryItem> => {
  const { data } = await openMetadataApiClient.get<TagCategoryItem>(`/classifications/name/${categoryName}`, {
    params: {
      fields: 'owners,usageCount,termCount,domains',
    },
  });
  return data;
};
